import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';

export const DEFAULT = '91086937-059c-4584-b7f6-83dd5c5b0efb';
export const NEW_HOMEOWNER = 'f86d3b7c-1127-45ba-8ed1-07f77ea08a8a';

class LuCommunicationContextAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'lu-communication-context';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'lus/communications/contexts';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'uuid',
      'created_at',
      'updated_at',
      'deleted_at',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'uuid',
      'name',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return [
    ];
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return [
    ];
  }

  /**
   * @returns {*}
   */
  validationRules() {
    return [
    ];
  }

}

export default LuCommunicationContextAppResource;
